import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Book, Chapter, UserBook } from '../models/book';

@Injectable({
    providedIn: 'root',
})
export class UserBookService {

    private readonly dummyUrls = [
        "../../../../assets/images/laura-story.svg",
        "../../../../assets/images/narnia-story.svg",
        "../../../../assets/images/peanut-man.svg",
        "../../../../assets/images/brick-story.svg",
    ];

    // Implementatation To Be Changed Later
    getBookInfo(bookId: string): Observable<UserBook> {
        const generateChapter = (type: string, title: string, hasSong = false, hasThumbnail = false, hasPageId = false, thumbnailUrl?: string): Chapter => ({
            route: "/chapter",
            chapterId: `${type.toLowerCase()}-${Math.random().toString(36).substring(7)}`,
            Type: type,
            title: title,
            description: `Description for ${title}`,
            songUrl: hasSong ? `${title.toLowerCase().replace(/\s/g, '')}.mp3` : null,
            thumbnailUrl: thumbnailUrl || null,
            //   thumbnailUrl:  null,
            ...(hasPageId && { pageId: `page-${Math.random().toString(36).substring(7)}` })
        });

        const generateSubTopic = (title: string): Chapter => ({
            ...generateChapter("SubTopic", title),
            subTopic: undefined
        });

        const generateRandomTitle = (base: string): string => {
            const length = Math.floor(Math.random() * 10) + 3; // Length between 3 and 12
            let randomTitle = base;
            for (let i = 0; i < length; i++) {
                randomTitle += String.fromCharCode(Math.floor(Math.random() * 26) + 97); // a-z
                if (i % 3 === 0 && i !== 0) {
                    randomTitle += " ";
                }
            }
            return randomTitle;
        };

        const mockBook: UserBook = {
            bookId,
            title: "Book Title",
            audioUrl: Math.random() > 0.5 ? `audio${Math.floor(Math.random() * 5) + 1}.mp3` : null,
            description: `Description for Book ${bookId}`,
            preface: generateChapter("Preface", generateRandomTitle("Preface")),
            story1: generateChapter("Story1", generateRandomTitle("Story 1"), false, true, true, this.dummyUrls[0]),
            story2: generateChapter("Story2", generateRandomTitle("Story 2"), true, true, true, this.dummyUrls[1]),
            story3: generateChapter("Story3", generateRandomTitle("Story 3"), true, true, true, this.dummyUrls[3]),
            story4: generateChapter("Story4", generateRandomTitle("Story 4"), false, true, true, this.dummyUrls[2]),
            chat: generateChapter("Chat", generateRandomTitle("Chat")),
            aboutTopic1: { ...generateChapter("AboutTopic", generateRandomTitle("About Topic 1")), subTopic: generateSubTopic(generateRandomTitle("Sub Topic 1")) },
            aboutTopic2: { ...generateChapter("AboutTopic", generateRandomTitle("About Topic 2")), subTopic: generateSubTopic(generateRandomTitle("Sub Topic 2")) },
            aboutTopic3: { ...generateChapter("AboutTopic", generateRandomTitle("About Topic 3")), subTopic: generateSubTopic(generateRandomTitle("Sub Topic 3")) },
            aboutTopic4: { ...generateChapter("AboutTopic", generateRandomTitle("About Topic 4")), subTopic: generateSubTopic(generateRandomTitle("Sub Topic 4")) },
            aboutTopic5: { ...generateChapter("AboutTopic", generateRandomTitle("About Topic 5")), subTopic: generateSubTopic(generateRandomTitle("Sub Topic 5")) }
        };

        return of(mockBook);
    }
}
